import { render, staticRenderFns } from "./myRead.vue?vue&type=template&id=5d699f49&scoped=true&"
import script from "./myRead.vue?vue&type=script&lang=js&"
export * from "./myRead.vue?vue&type=script&lang=js&"
import style0 from "./myRead.vue?vue&type=style&index=0&id=5d699f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d699f49",
  null
  
)

export default component.exports